var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17052_15175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 305,
    height: 305
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.002 8.00134H8.00195V312.001H312.002V8.00134Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17052_15175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.093 295.659L226.611 276.281L177.229 305.619L142.775 305.605L93.3646 276.281L27.9118 295.659L8.00195 228.864L27.9118 154.732L8.00195 92.0553L27.9118 14.375L130.187 75.1H189.817L292.093 14.375L312.001 92.0553L292.093 154.732L312.001 228.864L292.093 295.659Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9238 14.375L130.199 75.1427L126.132 116.847L27.9238 14.375Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.375 228.893L138.376 262.961L93.375 276.282V228.893Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.782 172.571L126.134 116.875L70.7708 154.746L70.7422 154.732V154.761L70.9135 193.743L93.3642 172.571H134.782Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.089 14.375L189.814 75.1427L193.868 116.847L292.089 14.375Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.635 228.893L181.635 262.961L226.635 276.282V228.893Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26 154.761V154.732L249.245 154.746L193.884 116.875L185.234 172.571H226.637L249.103 193.743L249.26 154.761Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3646 276.282L27.9118 295.659L8.00195 228.893H93.3646V276.282Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.769 172.565L147.272 253.08L129.945 208.312L70.8867 193.751L93.3514 172.565H134.769Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.641 276.282L292.093 295.659L312.004 228.893H226.641V276.282Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.238 172.565L172.734 253.08L190.062 208.312L249.12 193.751L226.641 172.565H185.238Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 228.865L27.9118 154.733H70.7286L70.886 193.731L129.945 208.291L147.271 253.059L138.365 262.918L93.3646 228.851L8.00195 228.865Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.004 228.865L292.094 154.733H249.276L249.12 193.731L190.062 208.291L172.734 253.059L181.641 262.918L226.641 228.851L312.004 228.865Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.815 75.1107H160.001H130.186L126.133 116.815L147.27 253.025H172.732L193.884 116.815L189.815 75.1107Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9118 14.375L8.00195 92.0553L27.9118 154.732H70.7286L126.119 116.847L27.9118 14.375Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.714 184.549H97.142L84.3066 197.049L129.907 208.288L120.714 184.531V184.549Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.093 14.375L312.003 92.0553L292.093 154.732H249.275L193.885 116.847L292.093 14.375Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.218 184.549H222.797L235.618 197.053L190.018 208.296L199.218 184.531V184.549Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.218 279.039L181.642 262.94L172.736 253.079H147.26L138.354 262.94L142.778 279.039",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.212 279.043V305.63H142.773V279.043H177.212Z",
    fill: "#E7EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.375 276.259L142.8 305.624V279.037L138.376 262.936L93.375 276.259Z",
    fill: "#E7EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.641 276.259L177.215 305.624V279.037L181.641 262.936L226.641 276.259Z",
    fill: "#E7EBF6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd4131a199c93e10db230b8e5cc2ed6c.svg";
export { ForwardRef as ReactComponent };